/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

import { parseOptions } from "./parseOptions";

// User status constants
export const USER_STATUS = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
} as const;

// Status badge colors mapping
export const STATUS_COLORS = {
  [USER_STATUS.PENDING]: "orange",
  [USER_STATUS.ACTIVE]: "green",
  [USER_STATUS.INACTIVE]: "red",
  DEFAULT: "gray",
} as const;


export const UTILITY_TYPES = "electricity, gas, water";
export const UTILITY_TYPES_OPTIONS = parseOptions(UTILITY_TYPES);
